export default function KitchenEquipmentIcon() {
  return (
    <>
      <path
        d='M71.3125 15H20.6875C20.2399 15 19.8107 15.1778 19.4943 15.4943C19.1778 15.8107 19 16.2399 19 16.6875V67.3125C19 67.7601 19.1778 68.1893 19.4943 68.5057C19.8107 68.8222 20.2399 69 20.6875 69H71.3125C71.7601 69 72.1893 68.8222 72.5057 68.5057C72.8222 68.1893 73 67.7601 73 67.3125V16.6875C73 16.2399 72.8222 15.8107 72.5057 15.4943C72.1893 15.1778 71.7601 15 71.3125 15ZM69.625 65.625H22.375V18.375H69.625V65.625Z'
        fill='#38383A'
        stroke='#FBF3F2'
      />
      <path
        d='M52.2622 38.1356L61.1891 29.1919V36.9375H64.5641V25.125C64.5641 24.6774 64.3863 24.2482 64.0698 23.9318C63.7533 23.6153 63.3241 23.4375 62.8766 23.4375H51.0641V26.8125H58.8097L49.8828 35.7394L52.2622 38.1356Z'
        fill='#38383A'
        stroke='#FBF3F2'
      />
      <path
        d='M29.125 60.5563H40.9375V57.1813H33.1919L42.1188 48.2544L39.7394 45.875L30.8125 54.8019V47.0563H27.4375V58.8688C27.4375 59.3163 27.6153 59.7455 27.9318 60.062C28.2482 60.3785 28.6774 60.5563 29.125 60.5563Z'
        fill='#38383A'
        stroke='#FBF3F2'
      />
    </>
  );
}
